let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bb7Ve")).then(() => parcelRequire('4H15d'));